module.exports = __webpack_public_path__ + "img/ns_out.25ef40db.jpg";